import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/agricultura/controle-praga-doenca' };
/////////////////////////////////////////////////////////////////////////////////

export function createControlePragaDoenca(payload) {
  return httpService.post({ ...args}, payload);
}

export function updateControlePragaDoenca(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listControlePragaDoenca(param) {
  return httpService.get({...args, args: param});
}

export function findControlePragaDoenca(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllControlePragaDoenca() {
  return httpService.get({ ...args, path: '/' });
}

export function deleteControlePragaDoenca(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

export function attachFilesControlePragaDoenca(itemId, payload) {
  return httpService.putAttachFiles({ ...args, args: `/attachFiles/${itemId}` }, payload);
}

export function deleteFilesControlePragaDoenca(itemId, filesIdList) {
  return httpService.putDeleteFiles({ ...args, args: `/deleteFiles/${itemId}` }, filesIdList);
}

export function marcarTratadoControlePragaDoenca(id) {
  return httpService.putNoBody({ ...args, args: `/marcar-tratado/${id}` });
}

export function marcarCanceladoControlePragaDoenca(id) {
  return httpService.putNoBody({ ...args, args: `/marcar-cancelado/${id}` });
}
